import React, { FC, useEffect, useState } from 'react'
import { ddayjs } from '@dt/fe-utils'

interface IProps {
  time: string;
  onEnd?: () => void;
  addTime?: number;
}

const BeforeSale: FC<IProps> = (props: IProps) => {
  const { time, onEnd, addTime = 0 } = props
  const [timeObj, setTimeObj] = useState<any>({
    day: '00',
    hour: '00',
    minute: '00',
    second: '00'
  })
  const tow = (n: number) => {
    return n >= 0 && n < 10 ? '0' + n : '' + n
  }
  useEffect(() => {
    if (time) {
      let timeInterval: any
      if (timeInterval) clearInterval(timeInterval)
      const getDate = () => {
        const currrntTime = ddayjs('brand').format('YYYY/MM/DD HH:mm:ss')
        const oldTime = new Date(currrntTime).valueOf()
        const newTime = ddayjs(time, 'brand').valueOf() + addTime
        const inter = newTime - oldTime
        if (inter <= 0) {
          clearInterval(timeInterval)
          onEnd && onEnd()
          return
        }
        let second = Math.floor((inter) / 1000)
        let day = Math.floor(second / 86400)
        second = second % 86400
        let hour = Math.floor(second / 3600)
        second %= 3600
        let minute = Math.floor(second / 60)
        second %= 60
        setTimeObj({
          day: tow(day),
          hour: tow(hour),
          minute: tow(minute),
          second: tow(second)
        })
      }
      getDate()
      timeInterval = setInterval(getDate, 1000)
      return () => {
        clearInterval(timeInterval)
      }
    }
  }, [time])
  return <span>{Number(timeObj.day) > 0 ? `${timeObj.day}:` : ''}{timeObj.hour}:{timeObj.minute}:{timeObj.second}</span>
}

export default BeforeSale
